export enum OralHealthEducationDataChartFields {
  educationText = 'educationText',
}

export const OralHealthEducationDataChartFormDefaultValues = {
  [OralHealthEducationDataChartFields.educationText]: '',
};
